import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-broom',
  imports: [],
  templateUrl: './icon-bold-broom.html',
  styleUrl: './icon-bold-broom.css'
})
export class IconBoldBroom {
@Input() size: string = '14';
@Input() color: string = 'currentColor';
}
